import styled from "styled-components";

export const AuthenticationContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin: 30px auto;
`;
